import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const FeatureCard = makeShortcode("FeatureCard");
const ArtDirection = makeShortcode("ArtDirection");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Wähle deinen Bereich`}</h2>
    <PageDescription mdxType="PageDescription">
    </PageDescription>
    <FeatureCard color="white" href="/developing/overview" title="Developing" actionIcon="arrowRight" className="homepage-feature" mdxType="FeatureCard">
      <ArtDirection mdxType="ArtDirection">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.15277777777778%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcSRAV//xAAXEAADAQAAAAAAAAAAAAAAAAABEBES/9oACAEBAAEFAhmL/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAEP/aAAgBAQAGPwJ//8QAGhAAAgIDAAAAAAAAAAAAAAAAAREAECExQf/aAAgBAQABPyElMF9hTxqv/9oADAMBAAIAAwAAABB4D//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPxAMn//EABwQAAICAgMAAAAAAAAAAAAAAAERITEAEIGRof/aAAgBAQABPxAFjoPNjr3JCENDta//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "dev section",
            "title": "dev section",
            "src": "/static/f1db2b0086805b5d57ad5e2ac217cdba/2e753/dev.jpg",
            "srcSet": ["/static/f1db2b0086805b5d57ad5e2ac217cdba/69549/dev.jpg 288w", "/static/f1db2b0086805b5d57ad5e2ac217cdba/473e3/dev.jpg 576w", "/static/f1db2b0086805b5d57ad5e2ac217cdba/2e753/dev.jpg 1152w", "/static/f1db2b0086805b5d57ad5e2ac217cdba/c8779/dev.jpg 1550w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcOZAV//xAAXEAEAAwAAAAAAAAAAAAAAAAABAhEg/9oACAEBAAEFAiJWf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABUQAQEAAAAAAAAAAAAAAAAAACAx/9oACAEBAAY/Aqv/xAAZEAEAAgMAAAAAAAAAAAAAAAABABEgIaH/2gAIAQEAAT8hQFO+RKUu8f/aAAwDAQACAAMAAAAQyA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAJ/8QAGxABAQABBQAAAAAAAAAAAAAAAREhACAxQYH/2gAIAQEAAT8QMKMGdri310QgAynDt//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "dev section",
            "title": "dev section",
            "src": "/static/6b0cc285d7625b86c6c38f514dc62419/2e753/dev-mobile.jpg",
            "srcSet": ["/static/6b0cc285d7625b86c6c38f514dc62419/69549/dev-mobile.jpg 288w", "/static/6b0cc285d7625b86c6c38f514dc62419/473e3/dev-mobile.jpg 576w", "/static/6b0cc285d7625b86c6c38f514dc62419/2e753/dev-mobile.jpg 1152w", "/static/6b0cc285d7625b86c6c38f514dc62419/38baa/dev-mobile.jpg 1538w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ArtDirection>
    </FeatureCard>
    <FeatureCard color="green" href="/design/get-started" title="Designing" actionIcon="arrowRight" className="homepage-feature" mdxType="FeatureCard">
      <ArtDirection mdxType="ArtDirection">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.638888888888886%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAMABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFBv/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAFLS5a5B0BIuP/EABwQAAEDBQAAAAAAAAAAAAAAAAIAAQQDEBETM//aAAgBAQABBQKF0a0UsG1UluJf/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/ARF//8QAFhEAAwAAAAAAAAAAAAAAAAAAAhAy/9oACAECAQE/AStf/8QAGBAAAgMAAAAAAAAAAAAAAAAAAAEgMUH/2gAIAQEABj8ChhSP/8QAGRABAQADAQAAAAAAAAAAAAAAAQARMVGB/9oACAEBAAE/IdPsZkNMXFGD/9oADAMBAAIAAwAAABAbz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QH//EABcRAAMBAAAAAAAAAAAAAAAAAAABIXH/2gAIAQIBAT8QSMEf/8QAHhABAAIBBAMAAAAAAAAAAAAAAQARMSFRsdFxkcH/2gAIAQEAAT8QN27cGFWD1CCaGNoWKac+IY+T3Lxwvc//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "blue vertical stripes",
            "title": "blue vertical stripes",
            "src": "/static/732118f3e18109f4893420187f9cc5c5/2e753/color-stripes-mobile.jpg",
            "srcSet": ["/static/732118f3e18109f4893420187f9cc5c5/69549/color-stripes-mobile.jpg 288w", "/static/732118f3e18109f4893420187f9cc5c5/473e3/color-stripes-mobile.jpg 576w", "/static/732118f3e18109f4893420187f9cc5c5/2e753/color-stripes-mobile.jpg 1152w", "/static/732118f3e18109f4893420187f9cc5c5/2f925/color-stripes-mobile.jpg 1607w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.583333333333336%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAIABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAIFBv/EABUBAQEAAAAAAAAAAAAAAAAAAAID/9oADAMBAAIQAxAAAAGt05FTFj//xAAZEAADAAMAAAAAAAAAAAAAAAAAAQIEEjP/2gAIAQEAAQUCxOqcm0n/xAAWEQADAAAAAAAAAAAAAAAAAAABEDH/2gAIAQMBAT8BEX//xAAWEQADAAAAAAAAAAAAAAAAAAACEDL/2gAIAQIBAT8BKl//xAAWEAEBAQAAAAAAAAAAAAAAAAAAATH/2gAIAQEABj8CjY2P/8QAGBABAQEBAQAAAAAAAAAAAAAAAQDhEVH/2gAIAQEAAT8hQdfbcTpl/9oADAMBAAIAAwAAABCHz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QD//EABcRAAMBAAAAAAAAAAAAAAAAAAABIXH/2gAIAQIBAT8QWcEf/8QAGhABAAIDAQAAAAAAAAAAAAAAAQARMVFhwf/aAAgBAQABPxBCYGzxlfzS6Vgh/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "blue vertical stripes",
            "title": "blue vertical stripes",
            "src": "/static/f8cba330487941e238047ab4a1ba567e/2e753/color-stripes.jpg",
            "srcSet": ["/static/f8cba330487941e238047ab4a1ba567e/69549/color-stripes.jpg 288w", "/static/f8cba330487941e238047ab4a1ba567e/473e3/color-stripes.jpg 576w", "/static/f8cba330487941e238047ab4a1ba567e/2e753/color-stripes.jpg 1152w", "/static/f8cba330487941e238047ab4a1ba567e/2f925/color-stripes.jpg 1607w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </ArtDirection>
    </FeatureCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      